import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-fil-bg px-4 sm:px-6 lg:px-8 py-12 sm:py-16" data-id="element-43" data-mp="1hbgtc9p1fr26">
      <div className="max-w-3xl mx-auto" data-id="element-44" data-mp="1cft11lf9ehsg">
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-fil-text leading-tight text-center mb-8 sm:mb-10" data-id="element-45" data-mp="2a28kutv5rrj6">
          Preguntas frecuentes
        </h2>

        <div className="space-y-3" data-id="element-46" data-mp="253p19041ertz">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={faq.q} className="bg-fil-card rounded-[1.25rem] border border-fil-beige overflow-hidden" data-id="element-47" data-mp="205vt41j6bnr2" data-mpi={i}>
                <h3 data-id="element-48" data-mp="oow35ckatl07">
                  <button onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} className="w-full px-5 sm:px-6 py-4 sm:py-5 flex items-center justify-between text-left hover:bg-fil-bg transition-colors duration-150 ease-out" data-id="element-49" data-mp="opfbq2o26x1k">
                    <span className="font-serif font-bold text-base sm:text-lg text-fil-text pr-5 leading-tight" data-id="element-50" data-mp="1koi1ttddpnbt">
                      {faq.q}
                    </span>
                    <ChevronDownIcon size={20} className={`text-fil-terra shrink-0 transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} data-id="element-51" data-mp="1aoiwe5c9ad36" />
                  </button>
                </h3>

                <AnimatePresence initial={false} data-id="element-52" data-mp="11wgxwclqz6vj">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-53" data-mp="16np8vd2q70at">
                      <p className="px-5 sm:px-6 pb-5 pt-1 text-sm sm:text-base text-fil-text/80 leading-relaxed border-t border-fil-beige" data-id="element-54" data-mp="n07ztedlezkp">
                        {faq.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}